import { Pagination } from '@mui/material';

import { Maybe } from '@/types';

import { getPaginationStyles } from '../BlogListPageDefault/BlogListPageDefault.styles';

export interface IPaginationProps {
	totalBlogs: number;
	countPerPage?: Maybe<number>;
	handlePaginationChangeEvent: (e: React.ChangeEvent<unknown>, page: number) => void;
}

export const getPaginationCount = (totalCount: number, countPerPage?: Maybe<number>) => {
	return Math.ceil(totalCount / (countPerPage ?? 12));
};

export default function BlogListPagination({
	totalBlogs,
	countPerPage,
	handlePaginationChangeEvent,
}: Readonly<IPaginationProps>) {
	const count = getPaginationCount(totalBlogs, countPerPage);

	return (
		<Pagination
			count={count}
			shape="rounded"
			size="large"
			sx={getPaginationStyles}
			boundaryCount={1} // Keeps 2 pages at the beginning and end (1, 2, ..., 19, 20)
			siblingCount={1} // Shows 1 page on either side of the current page (..., 11, [12], 13, ...)
			onChange={handlePaginationChangeEvent}
		/>
	);
}
